import logo from '../404.png';

/**
 * NoMatchPage - 404 Page
 * 
 * Will be shown when user ends up on route that does not exist.
 * 
 * @url "*"
 * @component None
 * @returns None
 */
const NoMatchPage = () => {

    // View
    return (
        <div className="splash">
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%"}}>
                <img src={logo} alt="logo" className="img-fluid animate__animated animate__shakeX" />
                <h1 className="text-light mt-5">Die aufgerufene Adresse konnte nicht gefunden werden.</h1>
            </div>
        </div>
    )
}

export default NoMatchPage;